import { useLocation, } from 'react-router-dom';
import { logout } from "./api/api";

const CheckUserInfo = () => {
    const { pathname } = useLocation();
    const isUserInfoEditPage = ["/user_info_edit"].includes(pathname) ? true : false;
    const isInquiryStatusPage = ["/inquiry_status"].includes(pathname) ? true : false;
    let userId = localStorage.getItem('userId');
    let sfUserId = localStorage.getItem('sfUserId');
    let companyId = localStorage.getItem('companyId');
    let isPb = localStorage.getItem("isPB");

    if (isUserInfoEditPage) {
        if (userId === null ||
            sfUserId === null) {
            logout();
            return;
        }
    } else {
        if (userId === null ||
            sfUserId === null ||
            companyId === null ||
            isPb === null) {
            logout();
            if (isInquiryStatusPage) {
                alert("再度ログインをお願いします。");
                window.location.replace("/fcc_login");
            }
            return;
        }
    }
    return;
}

export default CheckUserInfo;